const ROW_HEIGHT = {
  default: 51
};
const row = "dibr1xwtz8i";
const header = "dibh149yy4m";

export { ROW_HEIGHT, header, row };
import "./row.style.linaria.module.css";
//# sourceMappingURL=row.style.js.map
